import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { updatePointSetting, getEvaluatePointList as _getEvaluatePointList } from '@/services/systemsetting';
export default {
  name: 'basicSetting',
  components: {},
  i18n: require('./../i18n-basucSettings'),
  props: ['systemSetting'],
  watch: {
    systemSetting: function systemSetting() {
      var self = this;
      self.systemSettingData = self.systemSetting;
      self.initData();
    }
  },
  // },
  data: function data() {
    return {
      systemSettingData: this.systemSetting,
      loadingSave: false,
      rules: {
        productPointRate: [{
          required: true,
          message: this.$t('basicSettings.rewardGiftRatioErr'),
          trigger: 'blur'
        }],
        onePointMoney: [{
          required: true,
          message: this.$t('basicSettings.oneRewardConversionErr'),
          trigger: 'blur'
        }],
        rewardValidity: [{
          required: true,
          message: this.$t('basicSettings.rewardValidityErr'),
          trigger: 'blur'
        }]
      },
      rewardData: {
        id: '',
        productPointRate: '',
        onePointMoney: '',
        lastUpdateTime: '',
        rewardValidity: '',
        rewardValidityUnit: 1
      },
      evaluatePointList: [],
      isTableLoading: false,
      columns: [{
        //商品金额范围
        title: this.$t('basicSettings.productMoney'),
        dataIndex: 'productMoney',
        key: 'productMoney',
        width: '60%',
        scopedSlots: {
          customRender: 'productMoney' //自定义表格里面的内容
        }
      }, {
        title: this.$t('basicSettings.PresentedPointNumber'),
        dataIndex: 'pointNum',
        key: 'pointNum',
        width: '20%',
        align: "right"
      },
      //更新时间
      {
        title: this.$t('publicuse.updatetime'),
        dataIndex: 'lastUpdateTime',
        key: 'lastUpdateTime',
        width: '20%'
      }
      //操作
      /* {
      	title: this.$t('publicuse.action'),
      	dataIndex: 'action',
      	key: 'action',
      	scopedSlots: {
      		customRender: 'action'
      	},
      	width: '10%',
      } */]
    };
  },
  mounted: function mounted() {
    var self = this;
    self.initData();
  },
  methods: {
    initData: function initData() {
      var self = this;
      //初始化页面数据
      self.rewardData = {
        id: self.systemSettingData.id,
        productPointRate: self.systemSettingData.productPointRate,
        onePointMoney: self.systemSettingData.onePointMoney,
        lastUpdateTime: self.systemSettingData.lastUpdateTime,
        rewardValidity: self.systemSettingData.pointValidity,
        rewardValidityUnit: 1
      };
      self.getEvaluatePointList();
    },
    //获取评价赠送积分列表
    getEvaluatePointList: function getEvaluatePointList() {
      var self = this;
      self.isTableLoading = true;
      _getEvaluatePointList().then(function (res) {
        if (res.data.code == 200) {
          self.evaluatePointList = res.data.data;
          self.evaluatePointList.forEach(function (item, index) {
            if (index == 0) {
              item.startMoney = 0;
              item.endMoney = item.productMoney;
            } else {
              item.startMoney = self.evaluatePointList[index - 1].productMoney;
              item.endMoney = item.productMoney;
            }
          });
        }
      }).finally(function () {
        self.isTableLoading = false;
      });
    },
    /* 保存 */saveReward: function saveReward() {
      var _this = this;
      var self = this;
      this.$refs.rewardData.validate(function (valid) {
        if (valid) {
          self.loadingSave = true;
          updatePointSetting(self.rewardData).then(function (result) {
            if (result.data.code == 200) {
              //更新成功后更新 最后更新时间
              self.$emit('update');
              _this.$message.success(_this.$t('public.saveSuccessfully'));
            }
            self.loadingSave = false;
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    }
  }
};